<template>
  <div class="tree-node-manage-container">
    <el-row :gutter="24">
      <el-col :span="6">
        <div class="left-panel">
          <div class="search-panel">
            <el-input
              placeholder="请输入节点名称"
              prefix-icon="el-icon-search"
              v-model="searchPanelParams.name"
              @keyup.enter.native="clickSearchBtn"
            />
            <el-input
              style="margin-top: 12px"
              v-show="
                searchPanelParams.type == 'device' ||
                searchPanelParams.type == 'channel'
              "
              placeholder="请输入NVR编号"
              prefix-icon="el-icon-search"
              v-model="searchPanelParams.deviceId"
              @keyup.enter.native="clickSearchBtn"
            />
            <el-input
              style="margin-top: 12px"
              v-show="searchPanelParams.type == 'channel'"
              placeholder="请输入摄像头编号"
              prefix-icon="el-icon-search"
              v-model="searchPanelParams.channelId"
              @keyup.enter.native="clickSearchBtn"
            />
            <div style="margin-top: 12px; margin-left: 8px">
              <span style="font-size: 14px">节点类型：</span>
              <el-radio-group v-model="searchPanelParams.type" size="mini">
                <el-radio label="normal">所有</el-radio>
                <el-radio label="device">NVR</el-radio>
                <el-radio label="channel">摄像头</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="text-align: end">
            <el-button type="text" @click="clickSearchBtn">搜索</el-button>
            <el-button
              style="margin-right: 4px"
              type="text"
              @click="clickResetBtn"
              >重置</el-button
            >
          </div>
          <el-tree
            v-show="bLazyMode"
            ref="nodeTree"
            :props="props"
            lazy
            :load="loadNode"
            @node-click="handleNodeClick"
            :expand-on-click-node="false"
            node-key="id"
          >
            <span slot-scope="{ node, data }" class="slot-t-node">
              <template>
                <i
                  :class="{
                    'el-icon-folder': data.type == 'normal',
                    'el-icon-coin': data.type == 'device',
                    'el-icon-video-camera': data.type == 'channel',
                    'node-offline': data.status == 'offline'
                  }"
                />
                <span :class="{ 'node-offline': data.status == 'offline' }">{{
                  node.label
                }}</span>
              </template>
            </span>
          </el-tree>
          <el-tree
            v-show="!bLazyMode"
            default-expand-all
            :data="searchTreeData"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ node, data }" class="slot-t-node">
              <template>
                <i
                  :class="{
                    'el-icon-folder': data.type == 'normal',
                    'el-icon-coin': data.type == 'device',
                    'el-icon-video-camera': data.type == 'channel',
                    'node-offline': data.status == 'offline'
                  }"
                />
                <span :class="{ 'node-offline': data.status == 'offline' }">{{
                  node.label
                }}</span>
              </template>
            </span></el-tree
          >
        </div>
      </el-col>
      <el-col :span="18">
        <div class="right-panel">
          <div style="position: relative; min-height: 4px"></div>
          <div>
            <div v-if="curDetailData.id">
              <el-descriptions
                style="margin-left: 24px; margin-top: 18px; margin-right: 48px"
                title="节点详情"
              >
                <template slot="extra">
                  <el-button
                    style="margin-top: 12px; margin-left: 16px"
                    type="text"
                    @click="
                      handleEditCurrentNode(
                        curDetailData.parentId,
                        curDetailData.id,
                        curDetailData.name
                      )
                    "
                    >编辑节点</el-button
                  >
                  <el-button
                    style="margin-top: 12px; margin-left: 16px"
                    type="text"
                    size="small"
                    @click="
                      handleDeleteNode(curDetailData.id, curDetailData.name)
                    "
                    >删除</el-button
                  >
                </template>
                <el-descriptions-item label="名称">{{
                  curDetailData.name
                }}</el-descriptions-item>
                <el-descriptions-item label="ID">{{
                  curDetailData.id
                }}</el-descriptions-item>
                <el-descriptions-item label="类型">{{
                  curDetailDataTypeDesc
                }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                  <el-tag
                    size="mini"
                    type="success"
                    v-if="curDetailData.status == 'online'"
                    >在线</el-tag
                  >
                  <el-tag
                    size="mini"
                    type="danger"
                    v-else-if="curDetailData.status == 'offline'"
                    >离线</el-tag
                  >
                  <span v-else> - </span>
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="
                    curDetailData.type == 'device' ||
                    curDetailData.type == 'channel'
                  "
                  label="NVR编号"
                >
                  <span>{{ curDetailData.deviceId }}</span>
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="curDetailData.type == 'channel'"
                  label="摄像头编号"
                >
                  <span>{{ curDetailData.channelId }}</span>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="状态">
                <el-tag
                  v-if="curDetailData.status == 'online'"
                  type="success"
                  size="small"
                  >在线</el-tag
                >
                <el-tag v-else size="small">离线</el-tag>
              </el-descriptions-item> -->
              </el-descriptions>
              <div
                style="
                  font-size: 1rem;
                  font-weight: 700;
                  color: #303133;
                  margin-top: 24px;
                  margin-left: 24px;
                "
              >
                子节点列表
              </div>
              <el-card
                shadow="never"
                style="margin-top: 24px; margin-left: 3%; width: 94%"
              >
                <el-form label-position="right" size="small" :inline="true">
                  <el-form-item label="活动区域">
                    <el-radio-group
                      v-model="detailChildrenSearchPanelParams.type"
                    >
                      <el-radio-button label="">全部</el-radio-button>
                      <el-radio-button label="normal">区域节点</el-radio-button>
                      <el-radio-button label="device">NVR节点</el-radio-button>
                      <el-radio-button label="channel"
                        >摄像头节点</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item style="margin-left: 12px" label="节点名称">
                    <el-input
                      @keyup.enter.native="handleSearchDetailChildren"
                      v-model="detailChildrenSearchPanelParams.name"
                      placeholder="请输入节点名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin-left: 12px" label="NVR编号">
                    <el-input
                      @keyup.enter.native="handleSearchDetailChildren"
                      v-model="detailChildrenSearchPanelParams.deviceId"
                      placeholder="请输入NVR编号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin-left: 12px" label="摄像头编号">
                    <el-input
                      @keyup.enter.native="handleSearchDetailChildren"
                      v-model="detailChildrenSearchPanelParams.channelId"
                      placeholder="请输入摄像头编号"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div style="text-align: end">
                  <el-button type="text" @click="handleSearchDetailChildren"
                    >搜索</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleResetDetailChildrenSearchPanelParams"
                    >重置</el-button
                  >
                  <el-button
                    style="margin-top: 12px; margin-left: 16px"
                    type="text"
                    @click="handleAddChildNode"
                    >添加子节点</el-button
                  >
                </div>
              </el-card>
              <el-table
                :data="curDetailChildrenNodes"
                border
                style="width: 94%; margin-top: 24px; margin-left: 3%"
              >
                <el-table-column
                  prop="id"
                  label="ID"
                  align="center"
                  width="120"
                >
                </el-table-column>
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="类型"
                  align="center"
                  width="120"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 'normal'">区域节点</span>
                    <span v-else-if="scope.row.type == 'device'">NVR节点</span>
                    <span v-else-if="scope.row.type == 'channel'"
                      >摄像头节点</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="编号" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 'device'">{{
                      scope.row.deviceId
                    }}</span>
                    <span v-else-if="scope.row.type == 'channel'">{{
                      scope.row.channelId
                    }}</span>
                    <span v-else> - </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="创建时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                  <template slot-scope="scope">
                    <el-tag
                      size="mini"
                      type="success"
                      v-if="scope.row.status == 'online'"
                      >在线</el-tag
                    >
                    <el-tag
                      size="mini"
                      type="danger"
                      v-else-if="
                        scope.row.status == 'offline' &&
                        scope.row.type != 'normal'
                      "
                      >离线</el-tag
                    >
                    <span v-else> - </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEditTableChildNode(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="
                        handleDeleteTableChildNode(scope.$index, scope.row)
                      "
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: end; margin-top: 12px; margin-right: 24px"
                layout="prev, pager, next"
                :total="detailPaginationParams.count"
                :page-size="detailPaginationParams.size"
                :current-page="detailPaginationParams.page"
                @current-change="handleDetailCurrentPageChange"
              >
              </el-pagination>
            </div>
            <el-empty
              style="margin-top: 150px"
              v-else
              description="请选择节点"
            ></el-empty>
            <!-- <el-card
              style="margin: 24px"
              shadow="never"
              v-if="bShowAddChildNodeForm"
            >
              <div slot="header" class="clearfix">
                <span>子节点信息编辑</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="bShowAddChildNodeForm = false"
                  >关闭</el-button
                >
              </div>
            </el-card> -->
            <el-dialog
              style="min-width: 1100px"
              width="60%"
              title="添加子节点"
              :visible.sync="bShowAddChildNodeForm"
            >
              <AddChildNodeFormVue
                ref="addChildNodeForm"
                :parentId="selectedNodeData.nodeId"
                :parentType="selectedNodeData.type"
                @refresh="addChildNodeTriggerRefresh"
                @on-submit-finish="addChildNodeFinish"
              />
              <span slot="footer" class="dialog-footer">
                <el-button
                  :uplaoding="bUploadingChildNode"
                  @click="handleAddChildNodeCancel"
                  >取 消</el-button
                >
                <el-button
                  :uplaoding="bUploadingChildNode"
                  type="primary"
                  @click="handleAddChildNodeSubmit"
                  >保 存</el-button
                >
              </span>
            </el-dialog>
          </div>
        </div>
      </el-col>
    </el-row>
    <EditNodeDialog
      ref="editNodeDialog"
      :visible.sync="bShowEditNodeDialog"
      :nodeId="editNodeDialogId"
      @on-submit-finish="editNodeDialogTriggerRefresh"
    />
  </div>
</template>

<script>
import {
  queryChildrenByParentId,
  getRootNode,
  getNodeDetail,
  queryNodeByName,
  deleteNode,
  queryChildrenDetailByParentId
} from '@/api/tree';
import AddChildNodeFormVue from './nodeTree/AddChildNodeForm.vue';
import EditNodeDialog from './nodeTree/EditNodeDialog.vue';

export default {
  components: { AddChildNodeFormVue, EditNodeDialog },
  data() {
    return {
      editNodeDialogId: 0,
      detailPaginationParams: {
        page: 1,
        size: 10,
        count: 100
      },
      bLazyMode: true,
      bShowAddChildNodeForm: false,
      bShowEditNodeDialog: false,
      apis: {
        queryChildrenByParentId: '/uni/api/node/queryChildrenByParentId'
      },
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        nodeId: 'nodeId',
        type: 'type', // normal, device, channel
        status: 'status'
      },
      selectedNodeData: {},
      selectedNode: {},
      curDetailData: {},
      curDetailChildrenNodes: [],
      searchTreeData: [],
      searchTreeProps: {
        label: 'label',
        children: 'children'
      },
      searchPanelParams: {
        name: '',
        type: 'normal',
        deviceId: '',
        channelId: '',
        channelName: ''
      },
      bUploadingChildNode: false,
      detailChildrenSearchPanelParams: {
        type: '',
        name: '',
        deviceId: '',
        channelId: ''
      }
    };
  },
  computed: {
    curDetailDataTypeDesc() {
      let desc = '';
      if (this.curDetailData.type == 'normal') {
        desc = '区域节点';
      } else if (this.curDetailData.type == 'device') {
        desc = 'NVR节点';
      } else if (this.curDetailData.type == 'channel') {
        desc = '摄像头节点';
      }
      return desc;
    }
  },
  mounted() {
    // this.getSearchTreeData();
  },
  methods: {
    addChildNodeTriggerRefresh() {
        this.onRefreshCurrentTreeNode()
        this.handleSearchDetailChildren()
    },
    editNodeDialogTriggerRefresh() {
      const that = this;
      //   this.onRefreshCurrentTreeNode();
      //   this.onRefreshParentTreeNode();
      this.onRefreshRootNode();
      this.handleSearchDetailChildren();
      getNodeDetail(this.$axios, this.curDetailData.id).then((res) => {
        const detail = res.data.data;
        that.curDetailData = detail;
      });
    },
    handleDetailCurrentPageChange(val) {
      this.detailPaginationParams.page = val;
      this.handleSearchDetailChildren(false);
    },
    handleSearchDetailChildren(fromStart = true) {
      const that = this;
      if (fromStart) {
        this.detailPaginationParams.page = 1;
      }
      queryChildrenDetailByParentId(this.$axios, {
        parentId: this.curDetailData.id,
        type: this.detailChildrenSearchPanelParams.type,
        name: this.detailChildrenSearchPanelParams.name,
        deviceId: this.detailChildrenSearchPanelParams.deviceId,
        channelId: this.detailChildrenSearchPanelParams.channelId,
        page: this.detailPaginationParams.page,
        count: this.detailPaginationParams.size
      }).then((res) => {
        if (!res.data.code) {
          const list = res.data.data.list;
          if (list && list.length > 0) {
            that.curDetailChildrenNodes = [...list];
          }
          that.detailPaginationParams.count = res.data.data.total;
        }
      });
    },
    handleResetDetailChildrenSearchPanelParams() {
      this.detailChildrenSearchPanelParams = {
        type: '',
        name: '',
        devcieId: '',
        channelId: ''
      };
    },
    handleAddChildNodeSubmit() {
      const form = this.$refs.addChildNodeForm;
      if (form) {
        this.bUploadingChildNode = true;
        form.submitForm();
      }
    },
    handleAddChildNodeCancel() {
      this.bShowAddChildNodeForm = false;
    },
    addChildNodeFinish() {
      this.bUploadingChildNode = false;
    },
    handleEditTableChildNode(index, data) {
      this.editNodeDialogId = data.id;
      this.bShowEditNodeDialog = true;
      setTimeout(() => {
        this.$refs.editNodeDialog.setFormData(data.parentId, data.name);
      }, 100);
    },
    handleDeleteTableChildNode(index, data) {
      this.handleDeleteNode(data.id, data.name);
    },
    clickResetBtn() {
      this.searchPanelParams = {
        name: '',
        type: 'normal',
        deviceId: '',
        channelId: '',
        channelName: ''
      };
      this.bLazyMode = true;
    },
    clickSearchBtn() {
      if (
        this.searchPanelParams.name ||
        this.searchPanelParams.deviceId ||
        this.searchPanelParams.channelId ||
        this.searchPanelParams.channelName
      ) {
        this.getSearchTreeData();
        setTimeout(() => {
          this.bLazyMode = false;
        }, 100);
      } else {
        this.bLazyMode = true;
      }
    },
    getSearchTreeData() {
      const params = {
        name: this.searchPanelParams.name,
        type: this.searchPanelParams.type,
        deviceId:
          this.searchPanelParams.type == 'normal'
            ? ''
            : this.searchPanelParams.deviceId,
        channelId:
          this.searchPanelParams.type == 'channel'
            ? this.searchPanelParams.channelId
            : ''
      };
      queryNodeByName(this.$axios, params).then((res) => {
        if (!res.data.code) {
          const list = res.data.data;
          this.searchTreeData = this.listToTree(list);
          console.log('listToTree: ', list, this.searchTreeData);
        } else {
          this.searchTreeData = [];
        }
      });
    },
    listToTree(list) {
      const nodeMap = {};
      const roots = [];
      list.forEach((item) => {
        let node = Object.assign({}, item);
        node.children = [];
        node.label = node.name;
        node.nodeId = node.id;
        nodeMap[node.id] = node;
      });
      list.forEach((item) => {
        const node = nodeMap[item.id];
        if (item.parentId) {
          const parent = nodeMap[item.parentId];
          if (parent) {
            parent.children.push(node);
          }
        } else {
          roots.push(node);
        }
      });
      return roots;
    },
    onRefreshCurrentTreeNode() {
      if (this.bLazyMode) {
        this.selectedNode.loaded = false;
        this.selectedNode.expand();
      } else {
        this.getSearchTreeData();
      }
      this.bShowAddChildNodeForm = false;
    },
    onRefreshParentTreeNode() {
      const that = this;
      if (this.bLazyMode) {
        that.selectedNode.parent.loaded = false;
        that.selectedNode.parent.expand();
      } else {
        this.getSearchTreeData();
      }
    },
    onRefreshRootNode() {
      if (this.bLazyMode) {
        let root = this.selectedNode.parent;
        while (root.parent) {
          root = root.parent;
        }
        root.loaded = false;
        root.expand();
      } else {
        this.getSearchTreeData();
      }
    },
    loadNode(node, resolve) {
      const that = this;
      if (node.level === 0) {
        getRootNode(this.$axios).then((res) => {
          const data = res.data.data;
          return resolve([
            {
              name: data.name,
              nodeId: data.id,
              leaf: false,
              children: [],
              type: data.type,
              status: 'online'
            }
          ]);
        });
      } else {
        queryChildrenByParentId(this.$axios, node.data.nodeId).then((res) => {
          const data = res.data.data;
          const children = data.map((d) => {
            return {
              name: d.name,
              leaf: d.leafFlag,
              children: [],
              nodeId: d.id,
              type: d.type,
              status: d.type == 'normal' ? 'online' : d.status || 'offline'
            };
          });
          return resolve(children);
        });
      }
    },
    handleNodeClick(data, node) {
      if (data.nodeId == this.curDetailData.id) return;
      console.log('handleNodeClick data: ', data);
      console.log('handleNodeClick node: ', node);
      const tree = this.$refs.nodeTree;
      const that = this;
      this.selectedNodeData = data;
      this.selectedNode = node;
      this.bShowAddChildNodeForm = false;
      this.curDetailChildrenNodes = [];
      getNodeDetail(this.$axios, data.nodeId).then((res) => {
        const detail = res.data.data;
        that.curDetailData = detail;
      });
      queryChildrenDetailByParentId(this.$axios, {
        parentId: data.nodeId,
        page: that.detailPaginationParams.page,
        count: that.detailPaginationParams.size
      }).then((res) => {
        if (!res.data.code) {
          const list = res.data.data.list;
          if (list && list.length > 0) {
            that.curDetailChildrenNodes = [...list];
          }
          that.detailPaginationParams.count = res.data.data.total;
        }
      });
    },
    handleAddChildNode() {
      if (!this.curDetailData.id) {
        this.$message({
          type: 'warning',
          message: '请选择节点'
        });
        return;
      }

      if (this.curDetailData.type == 'channel') {
        this.$message({
          type: 'warning',
          message: '摄像头节点不可添加子节点'
        });
        return;
      }

      this.bShowAddChildNodeForm = true;
    },
    handleEditCurrentNode(parentId, id, name) {
      if (!this.curDetailData.id) {
        this.$message({
          type: 'warning',
          message: '请选择节点'
        });
        return;
      }

      this.editNodeDialogId = id;
      this.bShowEditNodeDialog = true;
      setTimeout(() => {
        this.$refs.editNodeDialog.setFormData(parentId, name);
      }, 100);
    },
    handleDeleteNode(id, name) {
      if (!this.curDetailData.id) return;

      const that = this;
      const title = `确认删除节点【${name}】？`;
      this.$confirm(title).then(() => {
        deleteNode(this.$axios, id).then((res) => {
          if (!res.data.code) {
            that.$message({
              type: 'success',
              message: '删除成功'
            });
            // that.curDetailData = {};
            that.handleSearchDetailChildren(false);
            that.onRefreshCurrentTreeNode();
            that.onRefreshParentTreeNode();
          } else {
            that.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.tree-node-manage-container {
  width: 100%;
  padding: 0;
  text-align: start;
}

.left-panel {
  min-height: 1000px;
  background-color: white;
  padding: 12px;
}

.right-panel {
  min-height: 1000px;
  background-color: white;
  padding-bottom: 48px;
}

.node-offline {
  color: #c0c0c0;
}

.search-panel {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/TreeNodeManage.vue